import { render, staticRenderFns } from "./Visit-follow-up-Detail.vue?vue&type=template&id=0a82a109&"
import script from "./Visit-follow-up-Detail.vue?vue&type=script&lang=js&"
export * from "./Visit-follow-up-Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports